// Mirrors the support service's upload rules: 25 MB per file,
// images / pdf / csv / txt / office docs.
export const MAX_ATTACHMENT_BYTES = 25 * 1024 * 1024
export const MAX_ATTACHMENT_COUNT = 5
export const ATTACHMENT_ACCEPT = 'image/*,.pdf,.csv,.txt,.doc,.docx,.xls,.xlsx'
